'use client';

import { __awaiter, __generator, __spreadArray, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Container, MoreButton } from './JobCardList.css.js';
import JobCard from '../JobCard/index.js';
import { searchJobs } from './services.js';
import { ELanguage } from '../Utils/constants.js';
import { getSpecialJob } from '../JobYouWillLove/services.js';
import Button from '../Button/index.js';
import translations from './translations.js';
import { isMobile } from '../Utils/helpers.js';

var JobCardList = function (props) {
    var _a;
    var api = props.api, langCode = props.langCode, previewJob = props.previewJob, _b = props.forceNormalJob, forceNormalJob = _b === void 0 ? false : _b, _c = props.useLoadMore, useLoadMore = _c === void 0 ? false : _c, userInfo = props.userInfo, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d, _e = props.isForceJobLinkVI, isForceJobLinkVI = _e === void 0 ? false : _e, headingTagTitleJob = props.headingTagTitleJob;
    var _f = useState([]), jobFull = _f[0], setJobFull = _f[1];
    var _g = useState(((_a = api === null || api === void 0 ? void 0 : api.params) === null || _a === void 0 ? void 0 : _a.page) || 0), page = _g[0], setPage = _g[1];
    var _h = useState(false), isShowLoadMore = _h[0], setIsShowLoadMore = _h[1];
    var isMobile$1 = isMobile();
    var t = function (key) {
        if (langCode === ELanguage.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var updateJobList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resultSearch, formatJobs, jobsNew;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, searchJobs({
                        baseUrl: api.baseUrl,
                        params: __assign(__assign({}, api.params), { page: page }),
                        langCode: langCode
                    })];
                case 1:
                    resultSearch = _b.sent();
                    if (!((resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data.length) > 0)) return [3 /*break*/, 5];
                    if (!(api === null || api === void 0 ? void 0 : api.accessToken)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: api.baseUrl,
                            accessToken: api.accessToken,
                            jobs: resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data
                        })];
                case 2:
                    formatJobs = _b.sent();
                    jobsNew = formatJobs === null || formatJobs === void 0 ? void 0 : formatJobs.data;
                    setJobFull(__spreadArray(__spreadArray([], jobFull, true), jobsNew, true));
                    return [3 /*break*/, 4];
                case 3:
                    setJobFull(__spreadArray(__spreadArray([], jobFull, true), resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data, true));
                    _b.label = 4;
                case 4:
                    if (((_a = resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.meta) === null || _a === void 0 ? void 0 : _a.nbPages) - 1 > page) {
                        setPage(page + 1);
                        setIsShowLoadMore(true);
                    }
                    else {
                        setIsShowLoadMore(false);
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleLoadMore = function () {
        updateJobList();
    };
    useEffect(function () {
        updateJobList();
    }, [api === null || api === void 0 ? void 0 : api.params]);
    return (React__default.createElement(Container, null,
        jobFull.map(function (job, idx) { return (React__default.createElement(JobCard, { key: idx, data: job, langCode: langCode, isMobile: isMobile$1, api: { accessToken: api.accessToken, baseUrl: api.baseUrl }, previewJob: previewJob, isManagementJobPage: false, custom: { forceNormalJob: forceNormalJob }, userInfo: userInfo, classSelector: classSelector, initData: props.initData, isForceJobLinkVI: isForceJobLinkVI, headingTagTitleJob: headingTagTitleJob })); }),
        useLoadMore && isShowLoadMore && (React__default.createElement(MoreButton, null,
            React__default.createElement(Button, { type: 'outline', className: 'customButton', onClick: handleLoadMore },
                ' ',
                t('More...'),
                ' ')))));
};

export { JobCardList as default };
//# sourceMappingURL=index.js.map
